type Environment = 'Preview' | 'Staging';

export const ENVIRONMENT_BANNER_HEIGHT = 24;

export const getEnvironment = (): Environment | null => {
  const forced = window.localStorage.getItem('forceEnvironment');
  if (forced === 'Preview' || forced === 'Staging') {
    return forced;
  }

  const { hostname } = window.location;

  if (hostname.toLowerCase().includes('preview')) {
    return 'Preview';
  }

  if (hostname.toLowerCase().includes('staging')) {
    return 'Staging';
  }

  return null;
};

const EnvironmentBanner = () => {
  const environment = getEnvironment();

  if (!environment) {
    return null;
  }

return (
  <div style={{
      backgroundColor: 'red',
      color: 'white',
      textAlign: 'center',
      width: '100%',
      height: ENVIRONMENT_BANNER_HEIGHT,
      position: 'fixed',
      bottom: 0,
      zIndex: 9999,
    }}
  >
    <strong>{ environment }</strong>
  </div>
  );
};

export default EnvironmentBanner;
